import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { UsendLoadingMark } from "./UsendMarks";
import { installLoadingTracker, subscribeLoading } from "./loadingTracker";
import styles from "./globalLoader.module.css";

const SHOW_AFTER = 300; // ms: quick loads never flash the pill
const MIN_VISIBLE = 600; // ms: once shown, it stays at least this long

// A small grey pill at the top centre while the app loads data, with the animated U-Send mark.
export default function GlobalLoader() {
  const [label, setLabel] = useState(null);
  const [visible, setVisible] = useState(false);
  const shownAt = useRef(0);
  const timer = useRef(null);

  useEffect(() => {
    installLoadingTracker();
    return subscribeLoading((next) => {
      clearTimeout(timer.current);
      // The Sync All toast already shows progress, so the pill stays away while it is up.
      if (next && !toast.isActive("order-sync")) {
        setLabel(next);
        if (!shownAt.current) {
          timer.current = setTimeout(() => {
            shownAt.current = Date.now();
            setVisible(true);
          }, SHOW_AFTER);
        }
      } else if (shownAt.current) {
        const wait = Math.max(0, MIN_VISIBLE - (Date.now() - shownAt.current));
        timer.current = setTimeout(() => {
          shownAt.current = 0;
          setVisible(false);
        }, wait);
      }
    });
  }, []);

  useEffect(() => () => clearTimeout(timer.current), []);

  return (
    <div className={`${styles.pill} ${visible ? styles.on : ""}`} role="status" aria-live="polite">
      {visible && (
        <>
          <UsendLoadingMark size={22} />
          <span>{label}</span>
        </>
      )}
    </div>
  );
}
